import { graphql, useStaticQuery } from 'gatsby';
export const useJoin = () => useStaticQuery(graphql `
      query UseJoin {
        cosmos {
          pages {
            page: join(dataKey: "page") {
              top_copy {
                header
                description
                icon {
                  ticket
                }
              }
              workable_url
              copy {
                markdown
                image {
                  ticket
                  fileName
                }
              }
              second_copy {
                markdown
                image {
                  ticket
                  fileName
                }
              }
              top_images {
                image {
                  ticket
                }
                caption
              }
            }
          }
        }
      }
    `).cosmos.pages;
export default useJoin;
